import { BaseControl, Button, TextControl } from '@wordpress/components';
import { __ } from '@wordpress/i18n';

const FieldOptions = ({ options, onChange }) => (
    <BaseControl __nextHasNoMarginBottom>
        <div className="field-options-repeater">
            <label style={{ fontWeight: '600', marginBottom: '0.5rem', display: 'inline-block' }}>
                {__('Options', 'voxycure-framework')}
            </label>
            {options.map((opt, idx) => (
                <div key={idx} style={{ display: 'flex', marginBottom: '8px', gap: '8px' }}>
                    <TextControl
                        field={{ type: 'text' }}
                        placeholder={__('Value', 'voxycure-framework')}
                        value={opt.value}
                        __next40pxDefaultSize={true}
                        __nextHasNoMarginBottom={true}
                        onChange={(value) => {
                            const updated = [...options];
                            updated[idx] = { ...updated[idx], value };
                            onChange(updated);
                        }}
                    />
                    <TextControl
                        field={{ type: 'text' }}
                        placeholder={__('Label', 'voxycure-framework')}
                        value={opt.label}
                        __next40pxDefaultSize={true}
                        __nextHasNoMarginBottom={true}
                        onChange={(value) => {
                            const updated = [...options];
                            updated[idx] = { ...updated[idx], label: value };
                            onChange(updated);
                        }}
                    />
                    <Button
                        isSmall
                        isDestructive
                        icon="no"
                        label={__('Remove Option', 'voxycure-framework')}
                        onClick={() => onChange(options.filter((_, i) => i !== idx))}
                    />
                </div>
            ))}
            <Button
                isSecondary
                isSmall
                icon="plus"
                onClick={() => onChange([...options, { value: '', label: '' }])}
            >
                {__('Add Option', 'voxycure-framework')}
            </Button>
        </div>
    </BaseControl>
);

export default FieldOptions;
